module.exports = __webpack_public_path__ + "static/media/home.737bab68.svg";